var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "46px",
    height: "45px",
    viewBox: "0 0 46 45",
    enableBackground: "new 0 0 46 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 46,
    height: 45,
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAtCAQAAAB7JJESAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAlwSFlzAAAhOAAAITgBRZYxYAAA AAd0SU1FB+kGEAcAOuGFjeIAAAHPSURBVFjDtZZtfYMwEIefVgEScDAcNBJwsDhYHRQH4KCdhCmg U8CmgDrIHLAPSXj5FcgL9M+HFrh7cjmSyx2Yl+BERkYKwIMH39y5s1EJFxq62atFbkEL2gXw5gHK HqGokKQkAGTk3EbDluZ5QDqaHlwsOMt+gCYMb9G3VbeEKhxvE1J42BbG9uqHlgHoMV76GLchkQCY 5Ch3aqRZYmkAPDEBOefa+k/xKSS1biRM3OFSdHSIZYOjeXmPgH8CkK/BTwB8RcB1QG9rJjrjWQQ8 dWX9QGd+Y+TwPUZBPWXhyWvgj2i49vlbg/8ArK3WRWUAxn8B/jsyDNM7gPFfkPAtQU9qXTsU7DY+ B6KlX9koomL3rIqJib0MQF/8y3RuTpaLJ/oj5CSCWwDeonUP45HMobEoHaf/0NvYRuTqTs6AX+6p 5KQfU6P/tWuAoSfpaLkieoeUnHIC02V6PJjHx5XOXlFxph4tQ9F/Lw98ynlxANvo2V1tlZlZeXYQ goq6T4SioZpsdP0mj8WvqzCfcdCO+GRmX+yIr1+JH/bFPD55Jb7Ympp5fO7TRcbj9ZONiZnHp+Z+ F03xqbmrN3Of8MMl94I/44v90FqShg5FbavQP3ElfF37OpFPAAAAJXRFWHRkYXRlOmNyZWF0ZQAy MDI1LTA2LTE2VDA3OjAwOjU4KzAwOjAwCIJ+3QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNS0wNi0x NlQwNzowMDo1OCswMDowMHnfxmEAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjUtMDYtMTZUMDc6 MDA6NTgrMDA6MDAuyue+AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.477c22bbbfb16e588268bbb7cc871fa6.svg";
export { ForwardRef as ReactComponent };